
const Roles = {
    ADMIN: { id: 1, name: "管理者" },
    MEMBER: { id: 2, name: "一般ユーザー" },
    CORP: { id: 3, name: "バックオフィス" },
    VIEWER: { id: 4, name: "閲覧者" },
    GUEST: { id: 5, name: "ゲスト" },
};

export default Roles;
